import React, { FC } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	centerImg: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& img': {
			width: '100%',
			height: 'auto',
			objectFit: 'contain',
			maxWidth: (props: { maxWidth?: number | string }) => props.maxWidth 
		},
	},
}));

interface CenterImageProps {
	className?: string;
	src: string;
	alt?: string;
	maxWidth?: number | string;
	style?: React.CSSProperties;
	divRef?: React.RefObject<HTMLDivElement>;
}

const CenterImage: FC<CenterImageProps> = ({ 
	className, src, style, divRef,
	maxWidth,
	alt = 'image'
}) => {
	const classes = useStyles({ maxWidth });

	return (
	<div ref={divRef} className={cx(classes.centerImg, className)} style={style}>
		<img src={ src } alt={ alt }/>
	</div>
	);
}

export default CenterImage;
